// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2NiTX","table__container":"styles_table__container__1_jqS","sortable":"styles_sortable__s6vP4"};